import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ListUsers } from '../../common/constants'
import { Role, RolesContext } from '../../contexts/RolesContext'
import { Button, ContainerPrimary, Content, Form, FormGroup, Input, Label } from './styled'


const Login: React.FC = () => {
  const navigate = useNavigate();
  // Acesse a Role usando useContext
  const context = useContext(RolesContext);
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  // Verifique se o contexto é nulo antes de acessar os valores
  if (!context) {
    return <div>Carregando...</div>;
  }

  const { roles, updateRoles } = context;  
  
  // Função para atualizar o group_active quando o usuário fizer login
  const handleLoginRoles = () => {
    // Verifique se o contexto existe
    if (!roles) return;

    // Crie um novo objeto que corresponde ao tipo Role com todas as propriedades obrigatórias
    const newRoles: Role = {
      ...roles,
      group_active: false, // Altere a propriedade group_active para false
    };

    // Atualize o contexto com o novo objeto
    updateRoles(newRoles);
  };

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();

    localStorage.removeItem('isAuthenticated');
    const isPrizeDraw = localStorage.getItem('isPrizeDraw');

    // Lógica de autenticação - procura o usuário correspondente
    const matchedUser = ListUsers.find(
      (u) =>
        login.toLowerCase() === u.user &&
        ((!isPrizeDraw && password.toLowerCase() === u.password) ||
          password.toLowerCase() === 'sabrieventos2023')
    );

    if (matchedUser) {
      localStorage.removeItem('isPrizeDraw');
      localStorage.setItem('isAuthenticated', login);
      localStorage.setItem('user', matchedUser.user);

      handleLoginRoles();

      if (!roles?.presentation_image) {
        navigate('/register');
      } else {
        navigate('/presentation');
      }
    } else {
      if (isPrizeDraw) {
        alert('Aplicação finalizada!');
      } else {
        alert('Usuário ou senha inválidos!');
      }
    }
  };
  return (
    <ContainerPrimary className="page-enter">
      <Content>
        {/* <Logo src={Logo1} alt="Logo" />
        <Logo src={Logo2} alt="Logo" /> */}
        <Form onSubmit={handleLogin}>
          <FormGroup>
            <Label htmlFor="login">Login</Label>
            <Input
              type="text"
              id="login"
              value={login}
              onChange={(e: { target: { value: React.SetStateAction<string> } }) => setLogin(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="password">Senha</Label>
            <Input
              autoComplete="off"
              type="password"
              id="password"
              value={password}
              onChange={(e: { target: { value: React.SetStateAction<string> } }) => setPassword(e.target.value)}
            />
          </FormGroup>
          <Button type="submit">ENTRAR</Button>
        </Form>
      </Content>
    </ContainerPrimary>
  );
};

export default Login;
